export default __webpack_public_path__ + "static/media/SL Back In.1c14d9d0.jpg";